export enum ExportGiftCardsStrategy {
    KTRONIX = "KTRONIX",
    DEFAULT = "DEFAULT",
    EXITO = "EXITO",
}

export interface ExportGiftCardsModalForm {
    partner?: string;
    strategy: ExportGiftCardsStrategy;
    onlyPending?: boolean;
}
